import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Gamepad2, BookOpen, Users } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BlockyCharacter3D from '../components/BlockyCharacter3D';

const ThankYouPage = () => {
  // Fire Google Ads conversion on page load
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-394266571',
        value: 1.0,
        currency: 'GBP',
      });
    }
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <section className="pt-28 pb-20 px-4">
        <div className="max-w-2xl mx-auto text-center">
          {/* Success icon */}
          <div className="w-20 h-20 bg-mint-green/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-mint-green" />
          </div>

          <h1 className="font-display text-4xl sm:text-5xl text-text-dark mb-4" data-testid="thank-you-heading">
            Thank You!
          </h1>
          <p className="font-body text-lg text-text-medium mb-10 max-w-lg mx-auto">
            Your request has been received. We'll be in touch shortly with everything you need to get started.
          </p>

          {/* Characters */}
          <div className="flex justify-center gap-4 mb-10">
            <BlockyCharacter3D size={70} skinTone="#3D2314" hairColor="#FF69B4" shirtColor="#EC4899" pantsColor="#3B82F6" hairStyle="braids" accessory="glasses" eyeStyle="happy" />
            <BlockyCharacter3D size={90} skinTone="#8D5524" hairColor="#00CED1" shirtColor="#22C55E" pantsColor="#1F2937" hairStyle="afro" accessory="headband" eyeStyle="happy" />
            <BlockyCharacter3D size={70} skinTone="#F5D0B0" hairColor="#8B5CF6" shirtColor="#F59E0B" pantsColor="#7C3AED" hairStyle="ponytail" accessory="bow" eyeStyle="happy" />
          </div>

          {/* What happens next */}
          <div className="bg-white border-2 border-soft-gray/30 rounded-2xl p-8 mb-10 text-left shadow-sm">
            <h2 className="font-display text-xl text-text-dark mb-6 text-center">What happens next?</h2>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-sunny-yellow/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <BookOpen className="w-5 h-5 text-sunny-yellow" />
                </div>
                <div>
                  <p className="font-body font-semibold text-text-dark">We'll review your request</p>
                  <p className="font-body text-sm text-text-medium">Our team will set up your school's free account within 24 hours.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-mint-green/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Users className="w-5 h-5 text-mint-green" />
                </div>
                <div>
                  <p className="font-body font-semibold text-text-dark">You'll receive login details</p>
                  <p className="font-body text-sm text-text-medium">We'll email you teacher and pupil login credentials to get started.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-lavender/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Gamepad2 className="w-5 h-5 text-lavender" />
                </div>
                <div>
                  <p className="font-body font-semibold text-text-dark">Start typing!</p>
                  <p className="font-body text-sm text-text-medium">Pupils can explore TypeTown, meet characters, and improve their typing skills.</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-mint-green to-sky-blue hover:from-sky-blue hover:to-mint-green text-white font-display text-lg rounded-xl transition-all shadow-md"
              data-testid="thank-you-home-btn"
            >
              Back to Home
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/for-schools"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white border-2 border-mint-green text-mint-green font-display text-lg rounded-xl hover:bg-mint-green/10 transition-all"
              data-testid="thank-you-schools-btn"
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ThankYouPage;
